import dayjs from 'dayjs';
import { TiergruppeAnimal } from '@ps20-frontend/shop-integration-redux';
import { DATEFORMAT_LOCAL_STATE, DATEFORMAT_SHORT_ISO } from '@ps20-frontend/utils';

export interface TiergruppeEntryFields<G> {
  cardId?: string;
  name?: string;
  geschlecht?: G;
  geburtsdatum?: string;
}

export const toLocalStateBirthDate = (birthDate: string | undefined): string | null => {
  if (!birthDate) {
    return null;
  }
  const date = dayjs(birthDate, DATEFORMAT_SHORT_ISO, true);
  return date.isValid() ? date.format(DATEFORMAT_LOCAL_STATE) : null;
};

export const findEntryOfCard = <E extends { cardId?: string }>(
  entries: E[],
  cardId: string | undefined,
): E | undefined => (cardId ? entries.find(entry => entry.cardId === cardId) : undefined);

export const tiergruppeEntryFieldsOf = <G>(
  animal: TiergruppeAnimal,
  genderOf: (gender: string) => G | null,
): TiergruppeEntryFields<G> => {
  const name = animal.name?.trim();
  const geschlecht = genderOf(animal.gender);
  const geburtsdatum = toLocalStateBirthDate(animal.birthDate);
  return {
    ...(animal.cardId ? { cardId: animal.cardId } : {}),
    ...(name ? { name } : {}),
    ...(geschlecht ? { geschlecht } : {}),
    ...(geburtsdatum ? { geburtsdatum } : {}),
  };
};
